import axios from "axios";
import { devApiUrl } from "../config";
import { CHUNK_SIZE } from "../constants";

const baseUrl = devApiUrl;

export default async function uploadFile(file, fileName, dataModelId) {
  let formData = new FormData();

  // Add the file to the form data
  // 'file' is the field name you will handle on the server side
  formData.append("file", new Blob([file]), fileName);
  formData.append("dataModelId", dataModelId);

  // Construct the URL;
  const fullUrl = `${baseUrl}/uploadfile`;

  try {
    const response = await axios.post(fullUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(response);
    // Optionally, you can return something here if you want to pass data along to the Promise.all() call
  } catch (error) {
    console.error(error);
    // If you throw the error here, it will be caught by your catch block in Promise.all() call
    throw error;
  }
}

/**
 * Uploads a file in chunks.
 *
 * This function breaks a file into smaller chunks and uploads them sequentially.
 * After all chunks are uploaded, it notifies the backend to combine these chunks.
 *
 * @param {File} file - The file to be uploaded.
 * @param {string} dataModelId - The ID of the data model associated with the file.
 * @param {string} fileName - The name of the file.
 */
export const uploadFileInChunks = async (
  file,
  dataModelId,
  fileName,
  setProcessing
) => {
  try {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

    for (let i = 0; i < totalChunks; i++) {
      // Calculate the fraction of completed chunks
      const completedFraction = (i + 1) / totalChunks;
      const updatedProcessing = {
        isProcessing: true,
        progress: completedFraction,
        action: "uploading",
      };
      setProcessing(updatedProcessing);
      const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
      await uploadChunk(chunk, i, fileName, dataModelId);

      //Updating state for frontend feedback here
    }
    // After all chunks are uploaded, notify the backend to combine them
    const finalResponse = await axios.post(`${devApiUrl}/combine-chunks`, {
      fileName,
      dataModelId,
    });

    return finalResponse.data;
  } catch (error) {
    console.error("Error uploading file in chunks:", error);
    // Handle or throw the error based on your error handling strategy
    throw error;
  }
};

/**
 * Uploads a single chunk of a file.
 *
 * This function creates a form data object containing the file chunk and other relevant information,
 * then sends a POST request to the server to upload this chunk.
 *
 * @param {Blob} chunk - The file chunk to be uploaded.
 * @param {number} chunkNumber - The sequence number of this chunk.
 * @param {string} fileName - The name of the file to which this chunk belongs.
 * @param {string} dataModelId - The ID of the data model associated with the file.
 */
const uploadChunk = async (chunk, chunkNumber, fileName, dataModelId) => {
  try {
    const formData = new FormData();
    formData.append("fileChunk", chunk);
    formData.append("chunkNumber", chunkNumber);
    formData.append("fileName", fileName);
    formData.append("dataModelId", dataModelId);

    await axios.post(`${devApiUrl}/upload-chunk`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    console.error(
      `Error uploading chunk ${chunkNumber} of file ${fileName}:`,
      error
    );
    // Handle or throw the error based on your error handling strategy
    throw error;
  }
};
